var _g, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUser = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  }, /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    stroke: "#449FDB",
    opacity: ""
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.724 94.092c-0.084 0-0.176-0.008-0.26-0.016-0.62-0.084-1.18-0.46-1.484-1.016l-16.752-30.124c-0.536-0.964-0.192-2.176 0.776-2.72 0.964-0.54 2.184-0.192 2.72 0.776l15.436 27.764 15.416-15.96c0.764-0.788 2.032-0.812 2.828-0.048 0.8 0.764 0.816 2.032 0.052 2.828l-17.28 17.9c-0.392 0.396-0.912 0.616-1.452 0.616z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.296 94.092c-0.54 0-1.064-0.224-1.436-0.608l-17.284-17.9c-0.76-0.804-0.744-2.068 0.052-2.828 0.788-0.772 2.064-0.752 2.828 0.048l15.412 15.952 15.436-27.76c0.532-0.968 1.752-1.316 2.72-0.776 0.968 0.536 1.312 1.752 0.772 2.724l-16.752 30.124c-0.304 0.548-0.86 0.92-1.484 1.008-0.092 0.008-0.176 0.016-0.264 0.016z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.008 76.196c-16.62 0-30.112-26.072-30.112-43.084 0-16.604 13.512-30.112 30.112-30.112s30.108 13.508 30.108 30.112c0 17.008-13.484 43.084-30.108 43.084zM60.008 6.996c-14.404 0-26.112 11.712-26.112 26.112 0 14.724 12.208 39.084 26.112 39.084s26.108-24.36 26.108-39.084c0-14.4-11.708-26.112-26.108-26.112z",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.196 117c-2.228 0-4.508-0.016-6.86-0.032-4.78-0.032-9.868-0.032-14.656 0-18.732 0.124-33.544 0.224-40.84-7.040-2.952-2.928-4.448-6.952-4.448-11.952 0-13.108 10.684-34.868 27.944-47.16l2.32 3.256c-15.716 11.18-26.264 31.728-26.264 43.9 0 3.952 1.072 6.936 3.264 9.116 6.12 6.084 20.908 5.992 38 5.876 4.792-0.032 9.896-0.032 14.7 0 17.092 0.116 31.86 0.212 37.984-5.876 2.196-2.18 3.264-5.164 3.264-9.116 0-12.164-10.556-32.712-26.256-43.9l2.32-3.256c17.256 12.292 27.936 34.048 27.936 47.16 0 5-1.5 9.024-4.452 11.96-6.38 6.336-18.496 7.064-33.956 7.064z",
    fill: "#000000"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/User.08de8183.svg";
export { ForwardRef as ReactComponent };